import { ApiClient } from '@webapp/core/services/ApiClient'
import { createLocalStorage } from '@webapp/core/services/LocalPersistentStorage'
import { GlobalSearchRecentsRepository } from './GlobalSearchRecentsRepository'
import { GlobalSearchRepository } from './GlobalSearchRepository'

export const globalSearchRecentsRepository = new GlobalSearchRecentsRepository({
  storage: createLocalStorage({ defaultTTL: null }),
})

export const globalSearchRepository = new GlobalSearchRepository({
  httpClient: ApiClient,
})
